import * as React from "react";
import { forwardRef, memo } from "react";
const SvgNearMeOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 11.667L19 5.0354L12.3684 19.0354L10.8947 13.1407L5 11.667Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgNearMeOutlined);
const Memo = memo(ForwardRef);
export default Memo;
